import { FilterDataTyped, FilterValue } from '@nexelem/filters';
import { isEmpty, pickBy } from 'lodash';
import { TaskFilterData as BEFilterData, TaskType, DateTimeRange } from '@nexelem/graphne-api';
import { DrawerFiltersData } from './components/TasksDrawerFilters';
import { formatISO } from 'date-fns';
import { DateRange } from '@nexelem/components';

const mapper = {
  queues: (filter: FilterValue<number[]>): BEFilterData['queues'] => (filter.value.length ? filter.value : undefined),
  name: (filter: FilterValue<string>): BEFilterData['name'] => filter.value?.toString(),
  productName: (filter: FilterValue<string>): BEFilterData['productName'] => filter.value?.toString(),
  taskTypes: (filter: FilterValue<TaskType[]>): BEFilterData['taskTypes'] => filter.value,
  showOrders: (filter: FilterValue<boolean | undefined>): BEFilterData['showOrders'] => filter.value,
  dueDate: (filter: FilterValue<DateRange>): BEFilterData['dueDate'] => {
    const { from, to } = filter.value;
    if (from && to) {
      return {
        from: formatISO(new Date(from)),
        to: formatISO(new Date(to)),
      };
    }
  },
};

export const filtersMapper = (
  filters: FilterDataTyped<DrawerFiltersData & { name?: string; productName?: string }>,
) => {
  const mappedFilters = {
    name: filters.taskName.value,
    productName: filters.taskName.value,
  } as Partial<Record<keyof typeof mapper, string | boolean | TaskType[] | DateTimeRange | undefined | number[]>>;

  const keys = Object.keys(mapper) as Array<keyof typeof mapper>;
  for (const key of keys) {
    const filter = filters[key];
    if (filter && mapper[key]) {
      mappedFilters[key] = mapper[key](filter as any);
    }
  }

  return pickBy(mappedFilters, (value: string | boolean | string[]) => value === true || !isEmpty(value));
};
